import { Card } from '@mui/material';
import type { Condition } from '@repo/api-gw-sdk';

import { Loader } from '@/components/layout/loading';
import {
  getResourcesScopeType,
  type ResourcesScopeType,
} from '@/components/resourcesSelection/resourceSelectionDynamicViewer';
import { ResourcesSelectionViewer } from '@/components/resourcesSelection/resourcesSelectionViewer';
import { useDAL } from '@/contexts/useDAL';

import { BackupScopeDynamicResourcesViewerHeader } from './components/backupScopeDynamicResourcesViewerHeader';
import { backupScopeSupportedProperties } from './components/backupScopeResourcesEditor';

export const backupScopesResourcesAllExcludedDescription =
  'Eon won’t discovered automatically any resources. Only manually included resources will be added once discovered.';
export const backupScopesResourcesAllIncludedDescription =
  'Eon will discover automatically all resources from your connected sources. When new ones are added, they’ll be included too.';

export const BackupScopesResources = ({
  panelType,
}: {
  panelType: 'right' | 'bottom';
}) => {
  const dal = useDAL();
  const {
    data: backupScope,
    isLoading,
    mutate,
  } = dal.inventory.backupScope.useList();
  const savedCondition: Condition | undefined = backupScope?.condition;
  const include: string[] = backupScope?.include ?? [];
  const exclude: string[] = backupScope?.exclude ?? [];
  const resourcesScopeType: ResourcesScopeType = getResourcesScopeType(
    savedCondition,
    'allIncluded'
  );
  const condition =
    resourcesScopeType === 'useConditions' ? savedCondition : undefined;

  return (
    <Card
      sx={{
        padding: '24px 40px 40px',
        margin: panelType === 'right' ? '40px' : '40px 0 40px 40px',
        overflowY: 'scroll',
        border: '1px solid var(--mui-palette-divider)',
      }}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <ResourcesSelectionViewer
          condition={condition}
          conditionTitle='Discover resources based on these conditions:'
          include={include}
          exclude={exclude}
          resourcesScopeType={resourcesScopeType}
          dynamicResourcesHeader={
            <BackupScopeDynamicResourcesViewerHeader
              panelType={panelType}
              resourcesScopeType={resourcesScopeType}
              condition={condition}
              onScopeChange={async () => {
                await mutate();
              }}
              include={include}
              exclude={exclude}
            />
          }
          allExcludedDescription={backupScopesResourcesAllExcludedDescription}
          allIncludedDescription={backupScopesResourcesAllIncludedDescription}
          supportProperties={backupScopeSupportedProperties.flat()}
        />
      )}
    </Card>
  );
};
